import { ChangeDetectorRef } from '@angular/core';
import { ALIANZA_CARRUSEL_FADE_MS } from '../../data/perfil-alianza.content';

/**
 * Fade out → cambia índice → fade in (hub + landing).
 * Sin motion si `prefers-reduced-motion: reduce`.
 */
export class AlianzaCarruselFade {
  /** false = opacity 0 (saliendo). */
  visible = true;

  private pending: number | null = null;
  private timer: ReturnType<typeof setTimeout> | null = null;

  destroy(): void {
    this.clear();
  }

  /**
   * @param apply Índice ya validado; el caller actualiza `indice` aquí.
   */
  goTo(
    next: number,
    current: number,
    apply: (indice: number) => void,
    cdr: ChangeDetectorRef
  ): void {
    if (next === current && this.pending === null) {
      return;
    }
    if (this.prefersReducedMotion()) {
      this.clear();
      this.visible = true;
      apply(next);
      cdr.markForCheck();
      return;
    }

    this.pending = next;
    if (!this.visible && this.timer) {
      return;
    }

    this.visible = false;
    cdr.markForCheck();
    this.clearTimerOnly();
    this.timer = setTimeout(() => {
      const target = this.pending ?? next;
      this.pending = null;
      this.timer = null;
      apply(target);
      // Siguiente frame: entra el nuevo contenido
      requestAnimationFrame(() => {
        this.visible = true;
        cdr.markForCheck();
      });
    }, ALIANZA_CARRUSEL_FADE_MS);
  }

  private clear(): void {
    this.clearTimerOnly();
    this.pending = null;
    this.visible = true;
  }

  private clearTimerOnly(): void {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  private prefersReducedMotion(): boolean {
    return (
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }
}
